import { useTranslationTyped } from 'i18n/i18n'
import { observer } from 'mobx-react-lite'
import { Trans } from 'react-i18next'
import { LtiFieldMappingHelpPage } from './LtiFieldMappingHelpPage'
import { stepComponents } from './stepComponents'

export const D2lFieldMappingPage = observer(function D2lFieldMappingPage() {
  const { tt } = useTranslationTyped()

  return (
    <LtiFieldMappingHelpPage
      content={tt.help.d2l}
      steps={
        <Trans i18nKey="help.d2l.update_steps" components={stepComponents} />
      }
    />
  )
})
